import { compareByPattern } from '../../modules/utils/filters'

export const SORT_DIRECTIONS_DICTIONARY = {
  ASC: 'ascending',
  DESC: 'descending'
}

/**
 * Sorts the given records by ascending.
 */
export const ascendingSort = (records, column) =>
  records.sort((itemA, itemB) => {
    if (typeof itemA[column] === 'number' && typeof itemB[column] === 'number') {
      return itemA[column] - itemB[column]
    }

    if (itemA[column]?.toString()?.toLowerCase() > itemB[column]?.toString()?.toLowerCase()) {
      return -1
    }
    return 1
  })

/**
 * Sorts the given records by descending.
 */
export const descendingSort = (records, column) =>
  records.sort((itemA, itemB) => {
    if (typeof itemA[column] === 'number' && typeof itemB[column] === 'number') {
      return itemB[column] - itemA[column]
    }

    if (itemA[column]?.toString()?.toLowerCase() < itemB[column]?.toString()?.toLowerCase()) {
      return -1
    }

    return 1
  })

/**
 * Filters the given records by the given pattern.
 */
export const filtering = (records, headers, cellProps, pattern) => {
  const updatedRecords = records.filter(item => {
    const enabledHeaders = headers.filter((_, index) => cellProps[index]?.enableFilter)

    return enabledHeaders.some(header => compareByPattern(item[header.value], pattern))
  })

  return updatedRecords.length > 0 ? updatedRecords : records
}
